import { $generateNodesFromDOM } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $createParagraphNode,
  $getRoot,
  $isDecoratorNode,
  $isElementNode,
} from "lexical";
import { useEffect, useRef } from "react";

/**
 * Replaces the editor content when `html` changes.
 * Skips the initial mount (handled by initialConfig.editorState).
 */
export default function UpdateContentPlugin({ html }) {
  const [editor] = useLexicalComposerContext();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    editor.update(() => {
      const root = $getRoot();
      root.clear();

      if (!html) return;

      const parser = new DOMParser();
      const dom = parser.parseFromString(html, "text/html");
      const nodes = $generateNodesFromDOM(editor, dom);

      const wrappedNodes = nodes.map((node) => {
        if ($isElementNode(node) || $isDecoratorNode(node)) {
          return node;
        }
        const paragraph = $createParagraphNode();
        paragraph.append(node);
        return paragraph;
      });

      root.append(...wrappedNodes);
    });
  }, [editor, html]);

  return null;
}
